import { combineReducers } from 'redux';
import { adminState, initialState as adminInitialState } from './admin';
import { blogState, initialState as blogInitialState } from './blog';
import { dashboardState, initialState as dashboardInitialState } from './dashboard';
import { profileState, initialState as profileInitialState } from './profile';
import { searchState, initialState as searchInitialState } from './search';
import { uiState, initialState as uiInitialState } from './ui';
import { userState, initialState as userInitialState } from './user';

export const emptyStoreData = {
    admin: adminInitialState,
    blog: blogInitialState,
    dashboard: dashboardInitialState,
    profile: profileInitialState,
    search: searchInitialState,
    ui: uiInitialState,
    user: userInitialState,
};

const reducer = combineReducers({
    admin: adminState,
    blog: blogState,
    dashboard: dashboardState,
    profile: profileState,
    search: searchState,
    ui: uiState,
    user: userState,
});

export default reducer;
